<template>
  <div class="form-section">
    <div class="row">
      <div class="col-12">
        <div class="input-wrapper">
          <div class="form-section-label">MOST RECENT PROFESSIONAL EXPERIENCE *</div>
          <div class="form-label">(please start with your current position)</div>
        </div>
      </div>
    </div>

    <template v-for="(item, index) in experience.duration">
      <recent-experience-duration :value="item" @input="value => experience.duration[index] = value" :key="index" :id="index" :countries="countries" :required="index === 0"></recent-experience-duration>
    </template>

    <div class="row" v-if="this.experience.duration.length < 3">
      <div class="col-12">
        <button class="btn-submit" type="button" @click.prevent="addDuration" style="width:auto;">
          <b>+</b> Add position
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="input-wrapper" :class="{error: errors.has('experience.operations')}">
          <div class="form-label">
            PLEASE OUTLINE YOUR MOTIVATION FOR ATTENDING THIS COURSE.
            MAX. 1000 CHARACTERS *
          </div>
          <textarea v-model="experience.operations" maxlength="1000" name="experience.operations" rows="5" placeholder=""></textarea>
          <small class="text-secondary">{{ 1000 - experience.operations.length }} characters left</small>
          <span v-if="errors.has('experience.operations')" class="error-msg"><br>{{ errors.get('experience.operations') }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="input-wrapper" :class="{error: errors.has('experience.reasons')}">
          <div class="form-label">
            HOW WILL YOU USE KNOWLEDGE AND SKILLS ACQUIRED THROUGH THIS TRAINING FOR YOUR
            CURRENT PROFESSIONAL RESPONSIBILITIES AND/OR FUTURE CAREER? MAX. 500 CHARACTERS *
          </div>
          <textarea v-model="experience.reasons" name="experience.reasons" rows="5" maxlength="500" placeholder=""></textarea>
          <small class="text-secondary">{{ 500 - experience.reasons.length }} characters left</small>
          <span v-if="errors.has('experience.reasons')" class="error-msg"><br>{{ errors.get('experience.reasons') }}</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import RecentExperienceDuration from './RecentExperienceDuration'

const duration = {
  to: '',
  from: '',
  country: '',
  employer: '',
  position: '',
  maintask: ''
}

const data = {
  duration: [
    { ...duration }
  ],
  operations: '',
  reasons: ''
}

export default {
  inject: [
    'errors'
  ],
  components: {
    RecentExperienceDuration
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      experience: { ...data }
    }
  },
  methods: {
    addDuration () {
      this.experience.duration.push({ ...duration })
    }
  },
  watch: {
    experience: {
      deep: true,
      immediate: true,
      handler: function (experience) {
        this.$emit('input', experience)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .input-wrapper {
        &.error {
            input {
                border-color: #c2063b;
            }
        }

        .error-msg {
            color: #c2063b;
        }
    }
</style>
